import { create } from 'zustand';

type ClickMockState = {
	show: boolean;
	setShow: (show: boolean) => void;
};

const loadInitialShow = (): boolean => {
	if (typeof sessionStorage === 'undefined') return true;
	try {
		const raw = sessionStorage.getItem('click-lottie');
		if (!raw) return true;
		return JSON.parse(raw).show ?? true;
	} catch {
		return true;
	}
};

export const useClickMockStore = create<ClickMockState>((set) => ({
	show: loadInitialShow(),
	setShow: (show) => {
		set({ show });
		try {
			sessionStorage.setItem('click-lottie', JSON.stringify({ show }));
		} catch {
			// ignore
		}
	},
}));
